export default __webpack_public_path__ + "static/logo-a143c37a946ddfa8c5fcf1a84689a804.svg";